import React, {Component} from 'react'
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"
import {createBrandNew} from "../../../../services/api/apiBrands";
import ListBrandsContext from "../../context/ListBrandsContext";
class AddBrandsPopup extends Component {
    static contextType = ListBrandsContext;

    state = {
        store: '',
        brandName: '',
        isCreating: false,
        error: ''
    }

    _handleChangeInput = (field) => e => {
        const {value} = e.target;
        if(field === 'brandName'){
            if(value.length < 51){
                this.setState({
                    error: ''
                });
            }else{
                this.setState({
                    error: 'Số ký tự của brand name nhỏ hơn hoặc bằng 50.'
                });
            }
        }

        this.setState({
            [field]: value
        });
    }

    _isDisable = () => {
        const {store, brandName} = this.state
        if(store !== '' && brandName !== '' && brandName.length < 51){
            return false
        }else{
            return true
        }
    }

    _handleClickAddBrand = () => {
        const {store, brandName} = this.state
        const value = this.context

        const {reLoadBrandsList} = value

        this.setState({
            isCreating: true,
            error: ''
        })

        const payload = {
            store,
            name: brandName,
        }

        createBrandNew(payload)
            .then(result => {
                const data = result.data
                if(data.success){
                    this.props.onTogglePopup()
                    reLoadBrandsList()
                    this.setState({
                        isCreating: false,
                        error: '',
                        store: '',
                        brandName: ''
                    })
                }else{
                    this.setState({
                        isCreating: false,
                        error: data.message
                    })
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    render() {
        const {isOpen, onTogglePopup} = this.props
        const {error, store, brandName} = this.state
        const isDisable = this._isDisable()
        return(
            <Modal isOpen={isOpen} toggle={onTogglePopup} className="add-brand-popup">
                <ModalHeader toggle={onTogglePopup}>Add new brand</ModalHeader>
                <ModalBody>
                    <div className="form-input">
                        <label className="font-weight-bold">Store <span>*</span></label>
                        <div className="box-input">
                            <input className="form-control" name="store" value={store} placeholder="Input namespace" onChange={this._handleChangeInput('store')}/>
                        </div>
                    </div>

                    <div className="form-input">
                        <label className="font-weight-bold">Brand name <span>*</span></label>
                        <div className="box-input">
                            <input className="form-control" name="brandName" value={brandName} placeholder="Input brand name" onChange={this._handleChangeInput('brandName')}/>
                            <span className="input-note">
                                {error ? error : ''}
                            </span>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className="d-flex justify-content-end">
                    <button className="btn btn-secondary" color="secondary" onClick={onTogglePopup}>cancel
                    </button>
                    <button onClick={this._handleClickAddBrand} className="btn btn-primary" disabled={isDisable}>
                        Add
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default AddBrandsPopup
